import { useEffect } from 'react'
import { datadogLogs } from '@datadog/browser-logs'
import AngleUpIcon from 'src/app/assets/icons/ico-angle-up.svg'
import { useGetCurrentPlayer } from 'src/store/player'
import { isAuthenticatedPlayer } from 'src/types/domain/Player'
import { useDeviceInfo } from 'src/hooks/useDeviceInfo'
import { TotalBetAmount } from './TotalBetAmount'
import { TotalBets } from './TotalBets'

type Props = Readonly<{
  isExpanded: boolean
  setIsExpanded: (isExpanded: boolean) => void
}>

export function BetListHeader({ isExpanded, setIsExpanded }: Props) {
  const currentPlayer = useGetCurrentPlayer()
  const { isMobile } = useDeviceInfo()

  useEffect(() => {
    if (!isMobile) {
      const timer = setTimeout(() => {
        setIsExpanded(true)
      }, 1000)

      return () => {
        clearTimeout(timer)
      }
    }
  }, [isMobile, setIsExpanded])

  const handleToggle = () => {
    setIsExpanded(!isExpanded)
    datadogLogs.logger.info('toggle_social_list', {
      user_action: {
        type: 'toggle_social_list',
        toggle: isExpanded ? 'expand' : 'collapse',
        playerId: isAuthenticatedPlayer(currentPlayer) ? currentPlayer.id : null
      }
    })
  }

  return (
    <div className="players-stats" onClick={handleToggle}>
      <div className="left">
        <TotalBetAmount />
        <TotalBets />
      </div>
      <div className="right">
        <div className="icon">
          <AngleUpIcon />
        </div>
      </div>
    </div>
  )
}
